import React from "react";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";

const RenderBtnPayment = ({ user, setFormConfig }) => {
  return (
    <div>
      <button
        className="btn-back-step"
        onClick={() => setFormConfig({ step: 4 })}
      >
        <ArrowIcon />
        Regresar
      </button>
      {user?.url_openpay.link && (
        <a
          href={user?.url_openpay.link}
          target="_blank"
          rel="noopener noreferrer"
          className="btn_payment_payu btn-openpay"
        >
          <img
            src="https://www.openpay.co/_ipx/_/img/header/openpay-color.svg"
            alt="Pago con Openpay"
          />
        </a>
      )}
    </div>
  );
};

export default RenderBtnPayment;
